
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loader from "../../Components/Loader/Loader"; 

const LoadingWrapper = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleStart = () => setLoading(true);
    const handleComplete = () => setLoading(false);

    
    handleStart();
    
    setTimeout(handleComplete, 1500);

    return () => handleComplete(); 
  }, [location]);

  return (
    <>
      {loading && <Loader />} {}
      {children} {}
    </>
  );
};

export default LoadingWrapper;
